import http from "../../../utils/httpService";
import { APPEARANCE_LOGOS_ROUTE } from "./constants";

/**
 *
 * @returns {*}
 */
const requestLogos = () => {
    return http.request(APPEARANCE_LOGOS_ROUTE, "GET");
};

/**
 *
 * @param logo
 * @returns {*}
 */
const requestLogoUpload = (logo) => {
    return http.request(APPEARANCE_LOGOS_ROUTE, "POST", logo, true);
};

/**
 *
 * @param id
 * @returns {*}
 */
const requestLogoDelete = (id) => {
    const route = APPEARANCE_LOGOS_ROUTE + `/${id}`;
    return http.request(route, "DELETE");
};

export { requestLogos, requestLogoUpload, requestLogoDelete };
